export default __webpack_public_path__ + "static/media/infographic_MSA.413ab15e.svg";